export default __webpack_public_path__ + "static/media/linkedin-sales-solutions-pAtA8xe_iVM-unsplash.1b74e231.jpg";